import { render, staticRenderFns } from "./archive-grievance.vue?vue&type=template&id=ee63f174&scoped=true&"
import script from "./archive-grievance.vue?vue&type=script&lang=js&"
export * from "./archive-grievance.vue?vue&type=script&lang=js&"
import style0 from "./archive-grievance.vue?vue&type=style&index=0&id=ee63f174&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee63f174",
  null
  
)

export default component.exports